import { useCallback, useState } from 'react';
import { Trans } from '@lingui/macro';
import { isFunction, noop } from 'lodash';
import PropTypes from 'prop-types';
import NgpTwoButtonDialog from '../dialog-two-button/NgpTwoButtonDialog';
import ConfirmMsgDiv from '../dialogs/ConfirmMsgDiv';

const Title = ({ label }) => {
    return <Trans>Confirm {label}</Trans>;
};

Title.propTypes = {
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};
Title.defaultProps = {
    label: null,
};

const ConfirmButtonText = ({ label }) => {
    return <Trans>{label}</Trans>;
};

ConfirmButtonText.propTypes = {
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};
ConfirmButtonText.defaultProps = {
    label: <Trans>Confirm</Trans>,
};

export function useDataTableActionDialog(confirmText) {
    const [open, setOpen] = useState(false);
    const [callbacks, setCallbacks] = useState({
        onDataTableAction: noop,
    });
    const showDialog = useCallback((onDataTableAction) => {
        setCallbacks({
            onDataTableAction: () => {
                if (isFunction(onDataTableAction)) {
                    onDataTableAction();
                }
            },
        });
        setOpen(true);
    }, []);

    const dialog = (
        <DataTableActionDialog
            open={open}
            onConfirm={() => callbacks.onDataTableAction()}
            setOpen={setOpen}
            confirmText={confirmText}
        />
    );

    return [dialog, showDialog];
}

function DataTableActionDialog({ plural, open, setOpen, onConfirm, confirmMsg, label }) {
    return (
        <NgpTwoButtonDialog
            title={<Title label={label} />}
            confirmButtonText={<ConfirmButtonText label={label} />}
            cancelButtonText={<Trans>Cancel</Trans>}
            open={open}
            setOpen={setOpen}
            onConfirm={onConfirm}
            isWarning
            closeInTitleBar={false}
        >
            <ConfirmMsgDiv plural={plural} confirmMsg={confirmMsg} label={label} />
        </NgpTwoButtonDialog>
    );
}

DataTableActionDialog.propTypes = {
    plural: PropTypes.bool,
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    onConfirm: PropTypes.func,
    confirmMsg: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

DataTableActionDialog.defaultProps = {
    plural: false,
    open: false,
    setOpen: noop,
    onConfirm: noop,
    confirmMsg: null,
    label: null,
};

export default DataTableActionDialog;
